import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x-3" }

import Image from "@/views/blocks/shared/section/media/image/Image.vue";
import type { FeatureProps } from "./FeatureProps";

export default /*@__PURE__*/_defineComponent({
  __name: 'Feature',
  props: {
    title: {},
    description: {},
    iconSrc: {},
    titleTextColor: {},
    descriptionTextColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(Image, {
      src: _ctx.iconSrc,
      alt: "",
      class: "mt-[2px] size-5 flex-none",
      width: "20",
      height: "20",
      "aria-hidden": "true"
    }, null, 8, ["src"]),
    _createElementVNode("span", null, [
      _createElementVNode("strong", {
        style: _normalizeStyle({ color: _ctx.titleTextColor })
      }, _toDisplayString(_ctx.title), 5),
      _cache[0] || (_cache[0] = _createTextVNode(" " + _toDisplayString(" ") + " ")),
      _createElementVNode("span", {
        class: "opacity-70",
        style: _normalizeStyle({ color: _ctx.descriptionTextColor })
      }, _toDisplayString(_ctx.description), 5)
    ])
  ]))
}
}

})